<div class="flex min-h-screen bg-n20">
  <!-- Mobile backdrop -->
  <div
    *ngIf="mobileOpen"
    class="fixed inset-0 bg-black/40 z-30 lg:hidden"
    (click)="mobileOpen = false"
  ></div>

  <!-- Sidebar -->
  <app-sidebar
    *ngIf="!coreConfig?.layout?.menu?.hidden"
    [mobileOpen]="mobileOpen"
    (close)="mobileOpen = false"
  >
  </app-sidebar>

  <!-- Main area -->
  <div class="flex-1 flex flex-col min-h-screen overflow-hidden min-w-0">
    <!-- Mobile top bar -->
    <div
      class="lg:hidden sticky top-0 bg-white border-b border-n30 px-4 py-3 flex items-center gap-3 z-20 shadow-sm"
    >
      <button
        (click)="mobileOpen = true"
        class="p-1 text-n700"
        aria-label="Open menu"
      >
        <i class="ph ph-list text-2xl"></i>
      </button>
      <img
        src="assets/images/logo/logo.png"
        alt="MobileWallet"
        class="h-8 w-auto"
      />
    </div>

    <!-- Page content -->
    <main class="flex-1 p-4 lg:p-6 overflow-auto">
      <content></content>
    </main>
  </div>
</div>
